				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class StorageRackService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('StorageRack');
	}
	
	loadAllForLocation(id: System.Guid, active: boolean) : Observable<TooBig4Car.Logic.StorageRack[]> {
		return this.myBaseService.loadAll(this.url + '/ForLocation/' + (id || '') + '?active=' + (active ?? true).toString());
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.StorageRack> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.StorageRack> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.StorageRack>{
		return this.myBaseService.get(id, this.url);
	}
	getStorageLabels(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id || '') + '/StorageLabels');
	}
}
				
